import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { DATE_FORMAT, REST_RESERVATION_EDIT } from '../../../../constants/DashboardConst';
import CustomReservedTableStatus from '../../../../shared/dashboard/custom-reserved-table-status/CustomReservedTableStatus';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { fetchRestaurantDashboardReservationDetails } from '../../DashboardSlice';
import { deleteRestaurantReservations } from '../../../../utils/dashboardAPIUtils';
import { useDispatch } from 'react-redux';
import CustomPopupModel from '../../../../shared/custom-popup/Custom-Popup';
import { decryptLocalStorage } from '../../../../utils/authUtils';

const DashboardRestaurantTableView = (props) => {
  const {
    onDrawerToggle,
    restaurantReservations,
    restaurantDashboardReservationTable,
    date,
    restaurantId,
    hotelId,
    restaurantTime,
    showLoader = () => {},
  } = props;
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const [timer, setTimer] = useState(0);
  const [reservationDetail, setReservationDetail] = useState({
    obj: null,
    anchorEl: null,
    open: false,
    tableNumber: null,
  });
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    obj: null,
  });

  const setTableStatus = (orderDetails) => {
    if (orderDetails.isReservedForGuest) {
      if (orderDetails.orderStatus === 'Completed') return orderDetails.orderStatus;
      const currentDate = moment().format('YYYY-MM-DD');
      const currStartTime = moment();
      // may require
      // const currEndTime = moment(currStartTime).add(1, "hour");
      const bookingStartTime = moment(orderDetails.reserveFrom, 'HH:mm');
      const bookingEndTime = moment(orderDetails.reserveUntil, 'HH:mm');
      // may require
      // const isBetweenStart = currStartTime.isBefore(bookingEndTime, "hours");
      // const isBetweenEnd = currEndTime.isAfter(bookingStartTime, "hours");
      const isSame = currStartTime.isSame(bookingStartTime);
      const isBetweenStart1 = currStartTime.isBetween(bookingStartTime, bookingEndTime);
      if (orderDetails.date === currentDate) {
        if (isSame || isBetweenStart1) return 'Occupied';
        return 'Reserved';
      }
      const isBefore = currStartTime.isBefore(bookingStartTime, 'hour');
      const nextDayRev = moment(currentDate, 'YYYY-MM-DD').isAfter(moment(date, DATE_FORMAT));
      if (isBefore || nextDayRev) return 'Reserved';
    }
    if (!orderDetails.isReservedForGuest) return 'Inactive';
  };

  const setBackgroundColor = (orderDetails) => {
    const currTableStatus = setTableStatus(orderDetails);
    if (currTableStatus === 'Reserved') return `#DBEAFE`;
    if (currTableStatus === 'Occupied') return `#C5F9E9`;
    if (currTableStatus === 'Inactive') return `#82828242`;
  };

  const setWidth = (startTime, endTime) => {
    let minWidth = 0;
    // const tableWidth = tableRef.current?.offsetWidth; // need to set for different resolution;
    switch (restaurantTime.length) {
      case 24:
        minWidth = 44.5;
        break;
      case 13:
        minWidth = 80;
        break;
      default:
        minWidth = 62;
        break;
    }
    const duration = moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'), 'minute');
    return `${(duration / 60) * minWidth}px`;
  };

  const setLeft = (startTime) => {
    const start = moment(startTime, 'HH:mm').get('minute');
    return `${start / 2}px`;
  };

  const isCurrentTimeLine = (time) => {
    if (moment(date, DATE_FORMAT).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD'))
      return false;
    const givenTime = moment(time, 'hh A');
    const currentTime = moment();
    const endTime = moment().add(1, 'hour');
    if (givenTime.isSame(currentTime, 'hour')) return true;
    if (givenTime.isAfter(currentTime, 'hour') && givenTime.isBefore(endTime, 'hour')) return true;
    return false;
  };

  const setCurrentTimeLineStyle = (type) => {
    let height = '';
    let left = '';
    if (restaurantDashboardReservationTable.length > 0)
      height = `${24 * restaurantDashboardReservationTable.length + 24}px`;
    else height = '24px';
    const currentTime = moment().format('m');
    left = currentTime / 2;
    if (type === 'line') return { height, left: `${left}px` };
    return { left: `${left - 4}px` };
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const getStartTime = moment().startOf('hour').format('hh A');
      isCurrentTimeLine(getStartTime);
      setCurrentTimeLineStyle('dot');
      setCurrentTimeLineStyle('line');
      setTimer(timer + 1);
    }, 30000);
    return () => clearTimeout(timer);
  }, [timer]);

  const showTableStatus = (e, timeDetails, tableNumber) => {
    setReservationDetail({
      obj: timeDetails,
      anchorEl: e.currentTarget,
      open: true,
      tableNumber: tableNumber,
    });
  };

  const onClose = () => {
    setReservationDetail({
      obj: null,
      anchorEl: null,
      open: false,
      tableNumber: null,
    });
  };

  const onEditReservation = (resDetail) => {
    onDrawerToggle(REST_RESERVATION_EDIT, true, resDetail);
    onClose();
  };

  const onClickRemoveReservation = (resDetail) => {
    setSelectedValue({
      id: resDetail.obj.id,
      name: resDetail.tableNumber,
      title: 'Remove Reservation',
      description:
        'Removing reservation for this table will make it available for assigning to new booking request.',
      status: true,
      anchorEl: resDetail.anchorEl,
      obj: resDetail.obj,
      cancel: 'No',
      buttonName: 'Yes',
    });
    onClose();
  };

  const onDeleteReservation = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';
      showLoader(true);
      if (selectedValue && selectedValue.id) {
        await deleteRestaurantReservations(selectedValue.id, restaurantId, hotelId, language);
        dispatch(fetchRestaurantDashboardReservationDetails(restaurantId));
        notificationManager('success', 'Reservation deleted successfully');
      }
      onCloseModel(true);
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Reservation');
      }
    }
  };

  const onCloseModel = (isFromDelete) => {
    if (!isFromDelete) {
      setReservationDetail({
        obj: selectedValue.obj,
        anchorEl: selectedValue.anchorEl,
        open: true,
        tableNumber: selectedValue.name,
      });
    }
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      obj: null,
    });
  };

  return (
    <div className='col-md-12 time-line-view p-2' ref={tableRef}>
      {restaurantTime.length > 0 ? (
        <table className='time-line-table'>
          <thead>
            <tr>
              <td className='left-title'>Table</td>
              {restaurantTime.map((time, timeNdx) => (
                <td className='time-line-timing' key={timeNdx}>
                  {time}
                  {isCurrentTimeLine(time) && (
                    <div className='current-time-line-rp'>
                      <div
                        className='current-time-line-dot'
                        style={setCurrentTimeLineStyle('dot')}
                      ></div>
                      <div
                        className='current-time-line'
                        style={setCurrentTimeLineStyle('line')}
                      ></div>
                    </div>
                  )}
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {restaurantReservations.map((reservations) => (
              <tr key={reservations.tableNumber}>
                <td className='time-line-number'>{('0' + reservations.tableNumber).slice(-2)}</td>
                {reservations.timings.map((timings, timingsNdx) => (
                  <td key={timingsNdx} className='time-line-td'>
                    {timings.details && (
                      <div
                        className='position-relative'
                        onClick={(e) =>
                          showTableStatus(
                            e,
                            {
                              ...timings.details,
                              tableStatus: setTableStatus(timings.details),
                            },
                            reservations.tableNumber,
                          )
                        }
                      >
                        {timings.details.orderStatus !== 'Completed' &&
                          timings.details.orderStatus !== 'No Show' && (
                            <div
                              className='time-line-event'
                              style={{
                                backgroundColor: setBackgroundColor(timings.details),
                                width: setWidth(
                                  timings.details.reserveFrom,
                                  timings.details.reserveUntil,
                                ),
                                left: setLeft(timings.details.reserveFrom),
                              }}
                            ></div>
                          )}
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className='restaurant-close'>We are close for the day</p>
      )}
      {reservationDetail.open && reservationDetail.obj.tableStatus !== 'Completed' && (
        <CustomReservedTableStatus
          tableStatus={reservationDetail}
          handleClose={onClose}
          onClickRemoveReservation={onClickRemoveReservation}
          onClickEdit={onEditReservation}
        />
      )}
      {selectedValue.id && selectedValue.status && (
        <CustomPopupModel
          popUp={selectedValue}
          onClickCancel={onCloseModel}
          onClick={onDeleteReservation}
        />
      )}
    </div>
  );
};

export default DashboardRestaurantTableView;
